<template>
  <v-sheet class="product-equity">
    <div class="equity-header">
      <div class="text-h5">商品权益</div>
      <v-btn color="primary" @click="onAdd">添加权益</v-btn>
    </div>
    <v-sheet class="product-equity-item" v-for="(item, index) in form.equity_s" :key="index">
      <v-row dense align="center" justify="space-between">
        <v-col cols="5">
          <v-select class="required" :items="equity_option_s" label="权益" v-model="item.equity_id" :disabled="hasId(item)"></v-select>
        </v-col>
        <v-col cols="7">
          <InputEquityAmount class="required" :label="getAmountLabel(item.equity_id)"
            :pattern="getPattern(item.equity_id)" v-model="item.amount" />
        </v-col>
      </v-row>
      <v-row dense align="center" justify="space-between">
        <v-col cols="5">
          <v-text-field label="价格权重" hint="按权重分配每项权益的价格" v-model="item.price_weight" type="number" min="0" />
        </v-col>
        <v-col cols="7" class="equity-button-wrapper">
          <v-btn class="equity-button" color="primary" outlined @click="onSave(index)">保存</v-btn>
          <v-btn class="equity-button" color="secondary" outlined @click="onDelete(index)">删除</v-btn>
        </v-col>
      </v-row>
    </v-sheet>
  </v-sheet>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { equityStore } from '@/store/equity'
import { productStore } from '@/store/product'
import InputEquityAmount from '@/components/InputEquityAmount.vue'
import { EquityPattern } from '@/plugins/payment'

const AMOUNT_LABEL_MAP = {
  [EquityPattern.SUBSCRIPTION]: '时长',
  [EquityPattern.PROMOTER]: '时长',
  [EquityPattern.CONSUMABLE]: '数量',
}

export default {
  components: { InputEquityAmount },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    let product = productStore.get(this.productId)
    let equity_s = product?.equity_s ?? []
    let form_equity_s = equity_s.map(item => {
      return {
        id: item.id,
        equity_id: item.equity_id,
        amount: item.amount,
        price_weight: item.price_weight,
      }
    })
    if (form_equity_s.length <= 0) {
      form_equity_s.push(this.emptyItem())
    }
    return {
      form: {
        equity_s: form_equity_s,
      },
    }
  },
  computed: {
    equity_option_s() {
      return this.getEquityOptionList()
    },
  },
  methods: {
    getEquityOptionList() {
      return equityStore.list.map(equity => {
        return {
          text: equity.name,
          value: equity.id,
        }
      })
    },
    emptyItem() {
      let option_s = this.getEquityOptionList()
      let equity_id = null
      if (option_s.length > 0) {
        equity_id = option_s[0].value
      }
      return {
        id: null,
        equity_id: equity_id,
        amount: null,
        price_weight: null,
      }
    },
    hasId(item) {
      return !_.isNil(item.id)
    },
    onAdd() {
      this.form.equity_s.push(this.emptyItem())
    },
    getAmountLabel(equity_id) {
      let pattern = equityStore.get(equity_id)?.pattern
      return _.isNil(pattern) ? '时长/数量' : AMOUNT_LABEL_MAP[pattern]
    },
    getPattern(equity_id) {
      return equityStore.get(equity_id)?.pattern ?? EquityPattern.CONSUMABLE
    },
    async onSave(index) {
      let item = this.form.equity_s[index]
      if (_.isNil(item.id)) {
        let product_equity = await productStore.doCreateEquity({
          product_id: this.productId,
          ...item,
        })
        item.id = product_equity.id
      } else {
        await productStore.doUpdateEquity({
          product_id: this.productId,
          ...item,
        })
      }
      this.$toasted.success('保存成功')
    },
    async onDelete(index) {
      let item = this.form.equity_s[index]
      if (!_.isNil(item.id)) {
        let product_equity = productStore.getEquity({ product_id: this.productId, id: item.id })
        let name = this.getProductEquityName(product_equity)
        const msg = `确定要删除商品权益「${name}」吗`
        if (!(await this.$dialog.confirm({ text: msg }))) {
          return
        }
        await productStore.doDeleteEquity({
          product_id: this.productId,
          id: item.id,
        })
        this.$toasted.success('删除成功')
      }
      Vue.delete(this.form.equity_s, index)
    },
    getProductEquityName(product_equity) {
      let equity = equityStore.get(product_equity.equity_id)
      return equity?.name || product_equity.id
    }
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.product-equity {
  padding-bottom: 64px;

  .equity-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .product-equity-item {
    border: solid 1px @antLineGrey;
    border-radius: 8px;
    margin-top: 16px;
    padding: 8px 16px 0 16px;
  }

  .equity-button-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;

    .equity-button {
      margin-left: 32px;
      margin-bottom: 8px;
    }
  }
}
</style>
